import React from 'react';
import PropTypes from 'prop-types';
import { Button, Popconfirm } from 'antd';
import classNames from 'classnames';
import NavigationOption from '~pages/pms-dashboard/properties/listing-management/navigation-bar/option';
import UploadProgress from '~pages/pms-dashboard/properties/listing-management/upload-progress';
import {
  propertySections,
  allPropertySections,
  noAcPropertySection,
  sectionPropertyState,
  propertyStatus,
} from '~constants/listing-management';
import { communicationStatus } from '~client/constants';
import { propertyDraftStatus } from '~constants/pending-approval';
import { Preview as PreviewIcon } from 'common/components/svgs';
import { authUrl } from '~settings/endpoints';
import ListingNoAvailable, {
  isInVentoryCountsEmpty,
} from '~pages/pms-dashboard/properties/listing-management/listingNoAvailable';
import { bookingJourneyType } from 'common/constants/booking';

export function showNavigationLabels(property) {
  let finalSections = [];
  if (
    property?.bookingJourney === bookingJourneyType.SEMI_AUTOMATIC ||
    property?.bookingJourney === bookingJourneyType.INSTANT_BOOK ||
    property?.bookingJourney === bookingJourneyType.MANUAL
  ) {
    finalSections = Object.keys(propertySections);

    if (property?.paymentPlan && !property?.paymentPlan?.paymentOnline) {
      const methodIndex = finalSections.findIndex(item => item === propertySections.PAYMENT_PLAN);
      finalSections.splice(methodIndex + 1, 0, allPropertySections.PAYMENT_METHOD);
    }
  } else {
    finalSections = Object.keys(noAcPropertySection);
  }

  // Filter out price calc display rule.
  if (
    property.billingCycle !== 'MONTHLY' ||
    property?.bookingJourney === bookingJourneyType.FULL_AUTOMATIC
  ) {
    finalSections.filter(section => section !== propertySections.PRICE_CALC_DISPLAY);
  }

  return finalSections;
}
export default class NavigationBar extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowUnpublishModal: false,
      isShowListingEmptyModal: false,
    };
  }

  calSectionState = section => {
    const {
      name,
      slug,
      headline,
      headlineCn,
      unitTypes,
      allImages,
      facilities,
      shippingCity,
      country,
      address,
      paymentPlan,
      offlinePaymentMethod,
    } = this.props.property;
    let sectionState = '';

    switch (section) {
      case propertySections.PROPERTY_DETAILS:
        if (name && slug && (headline || headlineCn)) {
          sectionState = sectionPropertyState.FILLED;
        } else {
          sectionState = sectionPropertyState.NOT_FILLED;
        }
        break;
      case propertySections.PROPERTY_ADDRESS:
        if (shippingCity && country && address) {
          sectionState = sectionPropertyState.FILLED;
        } else {
          sectionState = sectionPropertyState.NOT_FILLED;
        }
        break;
      case propertySections.PROPERTY_FACILITY:
        if (
          facilities &&
          facilities.some(facility => facility.group !== 'others' && facility.checked)
        ) {
          sectionState = sectionPropertyState.FILLED;
        } else {
          sectionState = sectionPropertyState.NOT_SUFFICIENT;
        }
        break;
      case propertySections.ROOM_CONFIG:
        if (unitTypes && unitTypes.edges.length > 0) {
          sectionState = sectionPropertyState.FILLED;
        } else {
          sectionState = sectionPropertyState.NOT_SUFFICIENT;
        }

        break;

      case propertySections.ACCEPTANCE_CRITERIA:
        sectionState = sectionPropertyState.FILLED;
        break;
      case propertySections.PRICE_AND_AVAILABILITY:
        if (
          unitTypes &&
          unitTypes.edges &&
          unitTypes.edges.some(unit => unit.node && unit.node.listings.length > 0) &&
          !this.props.isHaveUnconfirmedListing
        ) {
          sectionState = sectionPropertyState.FILLED;
        } else {
          sectionState = sectionPropertyState.NOT_SUFFICIENT;
        }

        break;
      case propertySections.PAYMENT_PLAN:
        sectionState = paymentPlan?.id
          ? sectionPropertyState.FILLED
          : sectionPropertyState.NOT_FILLED;
        break;
      case propertySections.PAYMENT_METHOD:
        sectionState = offlinePaymentMethod?.methodType
          ? sectionPropertyState.FILLED
          : sectionPropertyState.NOT_FILLED;
        break;
      case propertySections.PRICE_CALC_DISPLAY:
        sectionState = sectionPropertyState.FILLED;
        break;
      case propertySections.GALLERY_MANAGEMENT:
        if (
          allImages &&
          allImages.edges &&
          allImages.edges.some(
            image =>
              image.node &&
              image.node.hero &&
              image.node.status !== 'REJECTED' &&
              !image.node.deleted,
          )
        ) {
          sectionState = sectionPropertyState.FILLED;
        } else {
          sectionState = sectionPropertyState.NOT_FILLED;
        }
        break;
      default:
        sectionState = '';
    }

    return sectionState;
  };

  handleClickPreivew = () => {
    this.props.onPreview(res => {
      if (res && res.slug && res.city.slug && res.city.country && res.city.country.slug) {
        this.previewForm.action = authUrl(
          `${res.city.country.slug}/${res.city.slug}/p/${res.slug}?preview=yes&update_cache=yes`,
        );
        document.getElementById('preview_input').value = JSON.stringify({
          property: res,
        });
        this.previewForm.submit();
      }
      return false;
    });
  };

  calIsDisabled = () => {
    const {
      name,
      slug,
      headline,
      headlineCn,
      address,
      shippingCity,
      country,
      status,
      allImages,
      publishCondition,
    } = this.props.property;
    const { commissionTier, contractStage, paymentPlan, payout, listing, offlinePaymentMethod } =
      publishCondition;
    const payoutOrOfflinePaymentMethod = this.props.property?.paymentPlan?.paymentOnline
      ? payout
      : offlinePaymentMethod;

    if (
      name &&
      status !== 'NEW' &&
      slug &&
      address &&
      (headline || headlineCn) &&
      shippingCity &&
      country &&
      allImages &&
      allImages.edges &&
      allImages.edges.some(
        image =>
          image.node && image.node.hero && image.node.status !== 'REJECTED' && !image.node.deleted,
      ) &&
      commissionTier &&
      contractStage &&
      paymentPlan &&
      payoutOrOfflinePaymentMethod &&
      listing
    ) {
      return false;
    }

    return true;
  };

  handleConfirmPublish = () => {
    this.props.onClearUnconfirmedListings();
    this.props.onRequestPublish();
  };

  getAddonTag = section => {
    const categoryDraft = this.props.onCategoryDraft(section);
    if (!categoryDraft) {
      return null;
    }

    return (
      <span
        className={classNames('navigation-bar__draft-status', {
          'navigation-bar__draft-status--pending':
            categoryDraft.status === propertyDraftStatus.PENDING,
          'navigation-bar__draft-status--rejected':
            categoryDraft.status === propertyDraftStatus.REJECTED,
          'navigation-bar__draft-status--expired':
            categoryDraft.status === propertyDraftStatus.EXPIRED,
        })}
      >
        {this.props.t(`cms:cms.pending_approval.tag.${categoryDraft.status.toLowerCase()}`)}
      </span>
    );
  };

  publishHandle = hasInVentory => {
    const { isShowListingEmptyModal } = this.state;
    // listing available 为0 时，显示出 pop-up
    if (hasInVentory) {
      if (!isShowListingEmptyModal) {
        this.setState({ isShowListingEmptyModal: true });
        return;
      }
    }
    this.props.onRequestPublish();
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isHaveUnconfirmedListing) {
      this.setState({ isShowListingEmptyModal: false });
    }
  }

  render() {
    const { t, currentSection, property, publishStatus, isHaveUnconfirmedListing } = this.props;
    const { isShowListingEmptyModal } = this.state;
    const hasInVentory = isInVentoryCountsEmpty(property?.unitTypes?.edges);
    const availableLabels = showNavigationLabels(property);

    return (
      <div className="navigation-bar">
        <div className="navigation-bar__selection-wrap">
          <ul className="navigation-bar__selection">
            <For each="section" of={availableLabels} index="index">
              <NavigationOption
                key={index}
                sectionState={this.calSectionState(section)}
                text={t(`cms:cms.property.listing_management.${section.toLowerCase()}.navigation`)}
                isSelected={currentSection === section}
                handleSelectOption={() => this.props.handleSetSection(section)}
                isPublished={property.status === propertyStatus.PUBLISHED}
                addonTag={this.getAddonTag(section)}
              />
            </For>
          </ul>
        </div>
        <UploadProgress t={t} history={this.props.history} />
        <If condition={property.status !== propertyStatus.PUBLISHED}>
          <Choose>
            <When
              condition={
                property?.bookingJourney === bookingJourneyType.INSTANT_BOOK && this.calIsDisabled()
              }
            >
              <Button
                block
                type="primary"
                size="large"
                disabled
                loading={publishStatus === communicationStatus.FETCHING}
                className="navigation-bar__publish-btn"
              >
                {t('cms:cms.property.listing_management.publish.button')}
              </Button>
            </When>
            <When condition={isHaveUnconfirmedListing}>
              <Popconfirm
                placement="top"
                overlayStyle={{ maxWidth: 350 }}
                title={t('cms:cms.property.listing_management.unconfirmed_lisitings.publish.tips')}
                onConfirm={this.handleConfirmPublish}
                okText={t('cms:cms.properties.edit.btn.yes')}
                cancelText={t('cms:cms.properties.edit.btn.no')}
              >
                <Button
                  block
                  type="primary"
                  size="large"
                  disabled={this.calIsDisabled()}
                  loading={publishStatus === communicationStatus.FETCHING}
                  className="navigation-bar__publish-btn"
                >
                  {t('cms:cms.property.listing_management.publish.button')}
                </Button>
              </Popconfirm>
            </When>
            <Otherwise>
              <ListingNoAvailable
                confirmHandle={this.props.onRequestPublish}
                NewClass={'navigation-bar__publish-popUp'}
                isShow={isShowListingEmptyModal}
                onCancel={() => {
                  this.setState({ isShowListingEmptyModal: false });
                }}
              />

              <Button
                block
                type="primary"
                size="large"
                disabled={this.calIsDisabled() || isShowListingEmptyModal}
                loading={publishStatus === communicationStatus.FETCHING}
                className="navigation-bar__publish-btn"
                onClick={() => {
                  this.publishHandle(hasInVentory);
                }}
              >
                {t('cms:cms.property.listing_management.publish.button')}
              </Button>
            </Otherwise>
          </Choose>
          <form
            method="post"
            target="_blank"
            encType="application/json"
            ref={node => {
              this.previewForm = node;
            }}
          >
            <input type="hidden" id="preview_input" name="data" value="" />
            <Button block ghost type="primary" size="large" onClick={this.handleClickPreivew}>
              <PreviewIcon className="navigation-bar__preview-icon" />
              {t('cms:cms.property.listing_management.preview.button')}
            </Button>
          </form>
        </If>
      </div>
    );
  }
}

NavigationBar.propTypes = {
  t: PropTypes.func.isRequired,
  property: PropTypes.object,
  currentSection: PropTypes.string,
  handleSetSection: PropTypes.func,
  publishStatus: PropTypes.string,
  onPreview: PropTypes.func.isRequired,
  onRequestPublish: PropTypes.func.isRequired,
  isHaveUnconfirmedListing: PropTypes.bool,
  history: PropTypes.object,
  onClearUnconfirmedListings: PropTypes.func,
  onCategoryDraft: PropTypes.func,
};

NavigationBar.defaultProps = {
  t: () => {},
  property: {},
  currentSection: '',
  handleSetSection: () => {},
  publishStatus: '',
  onPreview: () => {},
  onRequestPublish: () => {},
  isHaveUnconfirmedListing: false,
  history: {},
  onClearUnconfirmedListings: () => {},
  onCategoryDraft: () => {},
};
